import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import CypherHQ from './cypherHQ';
import CypherBusiness from './cypherBusiness';
import CypherCard from './card/cypherCard';
import ActivateCard from './card/activateCard';
import Redirect from './components/redirect';
import FAQ from './faq';
import TelegramAuth from './telegramAuth';
import FooterSection from './components/footer';
import NavBar from './components/navbar';
import DappLanding from './dappLanding';
import ReactGA from 'react-ga4';
import React, { useEffect } from 'react';
import LegalTerms from './legal';

export default function App() {
  ReactGA.initialize('G-ZV64H3Y339');
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams) {
      const origin = searchParams.get('ref');
      if (origin && origin !== '') {
        ReactGA.set({
          userProperties: {
            origin,
          },
        });
      }
    }
  }, []);

  useEffect(() => {
    const origin = searchParams.get('ref');
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
      title: location.pathname + location.search,
      ...(origin && origin !== '' && { origin }),
    });
  }, [location]);

  return (
    <>
      <NavBar />
      <Routes>
        <Route path={'/'} element={<CypherHQ />} />
        <Route path={'/business'} element={<CypherBusiness />} />
        <Route path={'/card'} element={<CypherCard />} />
        <Route path={'/legal'} element={<LegalTerms />} />
        <Route path={'/activatecard'} element={<ActivateCard />} />
        <Route path='/twitter' element={<Redirect />} />
        <Route path='/linkedin' element={<Redirect />} />
        <Route path='/discord' element={<Redirect />} />
        <Route path='/reddit' element={<Redirect />} />
        <Route path='/youtube' element={<Redirect />} />
        <Route path='/medium' element={<Redirect />} />
        <Route path={'/faq'} element={<FAQ />} />
        <Route path={'/telegram/auth'} element={<TelegramAuth />} />
        <Route path={'/dapp'} element={<DappLanding />} />
        <Route path='*' element={<Navigate to={'/'} replace />} />
      </Routes>
      <FooterSection />
    </>
  );
}
